
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import Request from '../../utils/request';
const EVENT_CLICK = `click`;

const SELECTOR_CONTAINER = '.lta-match-result-edited';
const SELECTOR_DATA = '.lta-match-result-edited__data';

class MatchResultEdited {
	constructor() {
		this.init();
		this._data = [];
		this.loaded = 0;
		this.totalNotificationCount = 0;
	}

	init() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_CONTAINER);
		if(!this._wrapper){
			return;
		}
	}

	render() {
	}
}

const globalMatchResultEdited = new MatchResultEdited();
export default globalMatchResultEdited;
